import { FC, useState } from 'react';

import { IconType } from 'react-icons';

import { useTheme } from 'styled-components';

import { Typography } from '~/common/components/Typography';
import { Icon } from '~/common/components/Icons';

import {
  ArrowWrapper,
  IconWrapper,
  OptionContainer,
  OptionExtraContentWrapper,
  Title,
} from './styles';

import { IHorizontalTabOption } from '..';

interface IOptionFCProps {
  option: IHorizontalTabOption;
  current: string;
  highlighTitle: boolean;
  highlighIcon: boolean;
  withArrows: boolean;
  index: number;
  optionsLength: number;
  width?: string;
  customIcon?: IconType;
  onChange: (key: string) => void;
}

export const Option: FC<IOptionFCProps> = ({
  option,
  current,
  highlighIcon,
  highlighTitle,
  withArrows,
  index,
  optionsLength,
  width,
  customIcon: CustomIcon = null,
  onChange,
}) => {
  const theme = useTheme();
  const [hover, setHover] = useState<boolean>(false);

  return (
    <OptionContainer
      selected={option.key === current}
      highlighTitle={highlighTitle}
      highlighIcon={highlighIcon}
      width={width}
      onClick={() => onChange(option.key)}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {CustomIcon && (
        <CustomIcon
          size={20}
          color={
            option.key === current || hover
              ? highlighIcon
                ? theme.green[500]
                : theme.neutral[50]
              : highlighIcon
              ? theme.neutral[50]
              : theme.neutral[400]
          }
        />
      )}
      {option.icon && (
        <IconWrapper
          className={option.icon}
          selected={option.key === current}
          highlighIcon={highlighIcon}
        >
          <Icon
            type={option.icon}
            size={20}
            color={
              option.key === current || hover
                ? highlighIcon
                  ? theme.green[500]
                  : theme.neutral[50]
                : highlighIcon
                ? theme.neutral[50]
                : theme.neutral[400]
            }
          />
        </IconWrapper>
      )}
      <Title selected={option.key === current} highlighTitle={highlighTitle}>
        <Typography.Label
          color={
            option.key === current || hover
              ? highlighTitle
                ? 'green.500'
                : 'neutral.50'
              : highlighTitle
              ? 'neutral.50'
              : 'neutral.400'
          }
          size="small"
        >
          {option.title}
        </Typography.Label>
      </Title>
      {option.rightContent && (
        <OptionExtraContentWrapper>
          {option.rightContent}
        </OptionExtraContentWrapper>
      )}
      {withArrows && index < optionsLength - 1 && (
        <ArrowWrapper>
          <Icon
            type="arrow-right-s-line"
            color={
              option.key === current || hover
                ? highlighTitle
                  ? theme.green[500]
                  : theme.neutral[50]
                : highlighTitle
                ? theme.neutral[50]
                : theme.neutral[400]
            }
            size={20}
          />
        </ArrowWrapper>
      )}
    </OptionContainer>
  );
};
